import type { Movie } from "@/mocks/movies";
import MovieCard from "@/components/feature/MovieCard";

interface MovieGridProps {
  movies: Movie[];
  emptyText?: string;
  showViews?: boolean;
  columns?: string;
}

export default function MovieGrid({
  movies,
  emptyText = "暂无推荐内容，敬请期待",
  showViews = false,
  columns = "grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5",
}: MovieGridProps) {
  if (movies.length === 0) {
    return (
      <div className="w-full py-16 flex flex-col items-center justify-center text-center rounded-lg bg-background-100 border border-dashed border-background-300">
        <span className="w-14 h-14 rounded-full bg-background-200 flex items-center justify-center mb-4">
          <i className="ri-inbox-archive-line text-2xl text-foreground-500" />
        </span>
        <p className="text-sm text-foreground-600">{emptyText}</p>
      </div>
    );
  }

  return (
    <div className={`grid ${columns} gap-4 md:gap-5`}>
      {movies.map((movie) => (
        <MovieCard key={movie.id} movie={movie} showViews={showViews} />
      ))}
    </div>
  );
}